module.exports = __webpack_public_path__ + "static/img/MUTIAT.97b2d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MUTIAT.png
// module id = 9MVt
// module chunks = 0